//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'StrengthMeterPassword',
    props: {
        password: {
            type: String,
            required: true,
        },
        setPassword: {
            type: Function,
            required: true,
        },
        showErrors: {
            type: Boolean,
            required: true,
        },
        tabindex: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            areHintsVisible: false,
        };
    },
    computed: {
        computedPassword: {
            get() {
                return this.password;
            },
            set(val) {
                this.setPassword(val);
            },
        },
        isCharLengthValid() {
            return this.password.length >= 8;
        },
        hasUpperCaseLetter() {
            return /[A-Z]/.test(this.password);
        },
        hasLowerCaseLetter() {
            return /[a-z]/.test(this.password);
        },
        hasNumber() {
            return /[0-9]/.test(this.password);
        },
    },
    mounted() {
        this.$refs.strengthMeterPasswordWrapper.$el.setAttribute('tabindex', '-1');
    },
    methods: {
        showHints() {
            if (!this.areHintsVisible) {
                this.areHintsVisible = true;
            }
        },
    },
};
